const constant = {

    /**
  * Notification configuration
  */
    toastNotification: {
        /**
         * Toast Notification Position
         */
        position: "top-center",

        /**
         * Define time in mili second. Toast Notification will closed in time
         */
        autoCloseTimeOut: 1500,

        /**
         * it will show progress in notification
         */
        hideProgress: false,
    },

    mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,

    /**
       * Local Storage session key - access token
       */
    localStorageSessionKey: process.env.REACT_APP_LOCALSTORAGE_KEY
        ? process.env.REACT_APP_LOCALSTORAGE_KEY
        : "_token",

    /**
   * Local Storage session key - refresh token
   */
    localStorageSessionRefreshTokenKey: process.env.REACT_APP_LOCALSTORAGE_REFRESH_TOKEN_KEY
        ? process.env.REACT_APP_LOCALSTORAGE_REFRESH_TOKEN_KEY
        : "_refreshToken",

    /**
   * This is base url for api calling
   */
    baseURL: process.env.REACT_APP_API_BASEURL
        ? process.env.REACT_APP_API_BASEURL
        : "",
}

export default constant;